window.reparacoesData = window.reparacoesData || {};

window.reparacoesData["nova-11i"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-11-pro"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-10-pro"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-10"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-y90"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-y70"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "Sob consulta" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-9-se"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-9"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "149,90€" },
    { nome: "Tampa Traseira", preco: "59,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-8i"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Câmera frontal", preco: "39,90€" },
    { nome: "Câmera Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-5i"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["nova-5t"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p60-pro"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p50-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "289,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p40-lite-5g"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "89,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p40-pro-plus"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p40-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "429,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Conector de Carga", preco: "99,90€" },
    { nome: "Câmera Traseira", preco: "99,90€" },
    { nome: "Tampa Traseira", preco: "89,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p40-lite-e"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p40-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "89,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p40"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "189,90€" },
    { nome: "Conector de Carga", preco: "89,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p30-pro-new-edition"] = {
  "Reparações disponíveis": [
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p30-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "229,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Conector de Carga", preco: "79,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p30"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "189,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p30-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Conector de Carga", preco: "59,90€" },
    { nome: "Câmera frontal", preco: "59,90€" },
    { nome: "Câmera Traseira", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p20-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "189,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Conector de Carga", preco: "89,90€" },
    { nome: "Câmera frontal", preco: "59,90€" },
    { nome: "Câamera Traseira", preco: "99,90€" },
    { nome: "Tampa Traseira", preco: "59,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p20"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "79,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Conector de Carga", preco: "69,90€" },
    { nome: "Câamera frontal", preco: "59,90€" },
    { nome: "Câamera Traseira", preco: "59,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p20-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "39,90€" },
    { nome: "Conector de Carga", preco: "39,90€" },
    { nome: "Cââmara frontal", preco: "49,90€" },
    { nome: "Cââmara Traseira", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p-smart-2020"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p-smart-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "89,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["p-smart-2019"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "39,90€" },
    { nome: "Tampa Traseira", preco: "44,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-50-pro"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-40-pro"] = {
  "Reparações disponíveis": [
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-30-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "389,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "89,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-30"] = {
  "Reparações disponíveis": [
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-30-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "49,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-20-x"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "189,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-20-pro"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "189,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-20"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "99,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["mate-20-lite"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "69,90€" },
    { nome: "Bateria", preco: "39,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["y6p"] = {
  "Reparações disponíveis": [
    { nome: "Display/Touch", preco: "59,90€" },
    { nome: "Bateria", preco: "49,90€" },
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["y5p"] = {
  "Reparações disponíveis": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["y9s"] = {
  "Reparações disponíveis": [
    { nome: "Tampa Traseira", preco: "49,90€" },
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
